<ng-container *ngIf="dialog$ | async as dialog">
    <div class="paybee-modal-header pb-0">
        <div class="row">
            <div class="col-12">
                @if(isArray){
                  <div class="modal-main-heading">Draw Winners</div>
                  <div class="body-1 text-gray" >Draw winners <span class="text-bold">{{campaign.name}}</span></div>
                } @else{
                  <div class="modal-main-heading">Draw Winner</div>
                  <div class="body-1 text-gray">Draw a winner for <span class="text-bold">{{campaign.name}}</span></div>
                }
            </div> 
        </div>
    </div>
    <div class="modal-body">
      @if(isArray && !isSimpleRaffle){
        @for(winner of data; track $index){
          <div class="d-flex justify-content-between mt-3"
          [ngClass]="{'pb-5': $index === data.length-1}">
            <div class="d-flex">
              <img src="{{getImg(winner.BasketRaffleItem.image)}}" class="mr-3" style="width: 100px; height:50px;border-radius: 4px;" alt="">
              <div class="body-1 d-flex align-items-center">{{winner.BasketRaffleItem.name}}</div>
            </div>
            
            <div class="d-flex flex-column justify-content-around">
              <div class="body-2 grey-text" style="text-align:right">{{winner.Winner.name}}</div>
              <div class="caption grey-text">{{winner.Winner.email}}</div>
            </div>
          </div>
          
          @if($index !== data.length -1){
            <div class="divider mt-3"></div>
          }
        }
      }
      @else if(!isArray){
        <div class="text-center draw__title mb-4">And the winner is:</div>
        <div class="text-center draw__name mb-2">{{ data.name }}</div>
        <div class="text-center draw__email mb-2">{{ data.email }}</div>
      }

      
    </div>
    
    <div class="modal-footer paybee-modal-footer d-flex justify-content-between">
    <div class="d-flex">
        <div class="mr-2">
          <a (click)="onSaveWinners()" class="btn btn-sm modal-cancel-button waves-effect waves-light"
          style="text-transform: none;"
          >
          @if(campaign.campaignTypeData?.basketRaffleWinners){
            Update Winners
          }@else if (campaign.campaignTypeData?.raffleWinners){
            Save Winner
          } @else{
            Save Winners
          }
        </a>
        </div>

        @if(campaign.campaignTypeData?.raffleWinners || campaign.campaignTypeData?.basketRaffleWinners){
          <div>
            <a (click)="onShowWinnersClick()" class="btn btn-sm modal-cancel-button waves-effect waves-light"
            style="text-transform: none;"
            >See Winners</a>
          </div>
        }
      
    </div>
      <div>
      
        <a (click)="onClose()" class="btn btn-sm modal-confirm-button waves-effect waves-light">Done</a>
      </div>
    </div>  
  </ng-container>
  